import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import useTranslation from 'next-translate/useTranslation'

import queryGraphql from '@shared-components/queryGraphql'
import { CURRENT_MATCHES_V2 } from '@graphql/fixtures/fixtures.query'
import { pageLoading } from '@shared/libs/allLoader'
import Error from '@shared/components/error'
import { GET_ARTICLE_ID } from '@graphql/article/article.query'
import { checkRedirectionStatus, getTimeZone, handleApiError } from '@shared/utils'

const FixtureContent = dynamic(() => import('@shared-components/fixtureContent'), { loading: () => pageLoading() })
const CurrentMatches = dynamic(() => import('@shared/components/current-matches'))

function Fixtures({ data, seoData }) {
  const { t } = useTranslation()
  return (
    <FixtureContent
      type="currentMatches"
      seoData={seoData}
      title={t('common:LiveCricketScore')}
      description={`
        <p>Welcome to the ultimate destination for cricket enthusiasts - our comprehensive cricket website! Here, you get the latest cricket news from around the globe, catering to the diverse interests of cricket lovers everywhere. </p>
        <p>Stay informed with our extensive coverage of cricket news, analysis, interviews, match previews, reviews and much more. From the exhilarating highs of Test matches to the fast-paced excitement of T20 internationals and the strategic battles of One Day Internationals, we provide a complete picture of the cricketing world.</p>
        <p>Our live cricket scores section ensures that you never miss a moment of the action. In addition to international clashes, we shine a spotlight on the vibrant world of domestic cricket. Whether you're a casual follower or a hardcore enthusiast, our cricket website is your one-stop destination for everything cricket-related.</p>
        <p>Join us as we celebrate the passion, excitement, and drama of the world's most beloved sport, delivering unparalleled coverage and insights to cricket fans worldwide.</p>
      `}
    >
      <CurrentMatches data={data} status={'l'} />
    </FixtureContent>
  )
}

Fixtures.propTypes = {
  data: PropTypes.object,
  seoData: PropTypes.object
}

export default Error(Fixtures)

export async function getServerSideProps({ res, resolvedUrl, query }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=120')

    const [seoData, matched] = await Promise.all([
      queryGraphql(GET_ARTICLE_ID, { input: { sSlug: resolvedUrl.replaceAll('/', '').split('?')[0] || '' } }),
      queryGraphql(CURRENT_MATCHES_V2, { input: { eCategory: 'i', eStatus: 'l', sTimezone: getTimeZone(), nSkip: 1, nLimit: 10 } })
    ])
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.data?.getSeoData, query?.amp)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj

    return {
      props: {
        data: matched?.data,
        seoData: seoData?.data?.getSeoData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
